import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return(
      <footer id="footer">
        <img src="https://cdn.hidalgo.gob.mx/escudo_blanco.svg" alt="Escudo" style={{width:"150px",heigth:"150px",}}/>
        <ul className="icons crecer">
          <li>
            <a href="https://www.facebook.com/museointeractivoelrehilete/" target="blank">
              <img src="./images/Footer/Facebook.png" alt="Icono" style={{width:"20px",heigth:"20px",}}/>
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/museo_elrehilete/?hl=es" target="blank">
              <img src="./images/Footer/Instagram.png" alt="Icono" style={{width:"25px",heigth:"25px",}}/>
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@museoelrehilete?_t=8V8hSneJGEQ&_r=1" target="blank">
              <img src="./images/Footer/Tiktok.png" alt="Icono" style={{width:"25px",heigth:"25px",}}/>
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UC0gSoQ46glEOQNmGf-XnsZQ" target="blank">
              <img src="./images/Footer/Youtube.png" alt="Icono" style={{width:"25px",heigth:"25px",}}/>
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </li>
        </ul>
        <ul className="copyright">
          <li>&copy; Museo el Rehilete.</li>
          <li><a href="http://www.hidalgo.gob.mx/">Gobierno Del Estado De Hidalgo</a></li>
          <li><a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Aviso_Privacidad_Museo_Rehilete.pdf">Aviso de Privacidad</a></li>
        </ul>
      </footer>
    );
  }
}

export default Footer;